/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationAdminDto
 */
export interface CreateOrganizationAdminDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationAdminDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationAdminDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationAdminDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationAdminDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationAdminDto
     */
    backupEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationAdminDto
     */
    organizationId?: string | null;
}

/**
 * Check if a given object implements the CreateOrganizationAdminDto interface.
 */
export function instanceOfCreateOrganizationAdminDto(value: object): value is CreateOrganizationAdminDto {
    return true;
}

export function CreateOrganizationAdminDtoFromJSON(json: any): CreateOrganizationAdminDto {
    return CreateOrganizationAdminDtoFromJSONTyped(json, false);
}

export function CreateOrganizationAdminDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationAdminDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'backupEmail': json['backupEmail'] == null ? undefined : json['backupEmail'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
    };
}

export function CreateOrganizationAdminDtoToJSON(json: any): CreateOrganizationAdminDto {
    return CreateOrganizationAdminDtoToJSONTyped(json, false);
}

export function CreateOrganizationAdminDtoToJSONTyped(value?: CreateOrganizationAdminDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'phoneNumber': value['phoneNumber'],
        'backupEmail': value['backupEmail'],
        'organizationId': value['organizationId'],
    };
}

